module.exports = __webpack_public_path__ + "img/emoji-frown.b1cff1dd.svg";